export const OrderStatus = {
  DRAFT: 'DRAFT',
  SEARCH: 'SEARCH',
  ASSIGNED: 'ASSIGNED',
  DRIVING: 'DRIVING',
  ARRIVED: 'ARRIVED',
  INSPECTION: 'INSPECTION',
  APPRAISAL: 'APPRAISAL',
  BUYING: 'BUYING',
  DOCUMENT_PREPARATION: 'DOCUMENT_PREPARATION',
  PAYMENT_TRANSFER: 'PAYMENT_TRANSFER',
  TRANSPORTATION: 'TRANSPORTATION',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  REFUSED_BY_INSPECTOR: 'REFUSED_BY_INSPECTOR',
  REFUSED_BY_SELLER: 'REFUSED_BY_SELLER',
  REFUSED_BUYOUT: 'REFUSED_BUYOUT',
} as const

export type OrderStatus = (typeof OrderStatus)[keyof typeof OrderStatus]

export const UserRole = {
  admin: 'admin',
  dispatcher: 'dispatcher',
  manager: 'manager',
  customer_supervisor: 'customer_supervisor',
  contractor_supervisor: 'contractor_supervisor',
  inspector: 'inspector',
  /** Сотрудник компании-партнёра воронки лидов: заводит заявки и видит их ход. */
  partner_operator: 'partner_operator',
  /** Сотрудник партнёра: только просмотр заявок. */
  partner_viewer: 'partner_viewer',
} as const

export type UserRole = (typeof UserRole)[keyof typeof UserRole]

export const CompanyType = {
  customer: 'customer',
  contractor: 'contractor',
} as const

export type CompanyType = (typeof CompanyType)[keyof typeof CompanyType]
